import Post from '../../libs/request/post'

const state = {
  icons: null,
  isLoading: false,
  docData: []
}
const getters = {
  getIcons: state => state.icons,
  getDocData: state => state.docData
}

const mutations = {
  setIcons (state, field) {
    state.icons = field
  },
  setLoading (state, isLoading) {
    state.isLoading = isLoading
  },
  setDocData (state, docData) {
    state.docData = docData
  }
}
const actions = {
  getFieldList ({commit}, data) {
    commit('setLoading', true)
    Post.login(data).then((res) => {
      commit('setLoading', false)
      if (res) {
        commit('setIcons', res)
      }
    }).catch((res) => {
      commit('setLoading', false)
    })
  }
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}

export {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/field.js